import { render, staticRenderFns } from "./FotoTextoLanding2.vue?vue&type=template&id=5bb90fed&scoped=true&"
import script from "./FotoTextoLanding2.vue?vue&type=script&lang=js&"
export * from "./FotoTextoLanding2.vue?vue&type=script&lang=js&"
import style0 from "./FotoTextoLanding2.vue?vue&type=style&index=0&id=5bb90fed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb90fed",
  null
  
)

export default component.exports